const externalUrls = {
    HERITAGE_FUNNEL: process.env.VUE_APP_HERITAGE_FUNNEL,
    SAFELITE_HOP: process.env.VUE_APP_SAFELITE_HOP,
};

export { externalUrls };
